import React, { Fragment, useEffect, useState } from "react";
import logo from "../assets/SVG/Logo_new.svg";
import { NavLink } from "react-router-dom";
import { getUser } from "@/utils/localStorage.tsx";
import {InstallPWAButton} from "@/components/index.tsx";

const Header: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 899);
  };

  const user = getUser();

  useEffect(() => {
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  return (
    <div className="header">
      <div className="header__logo">
        <img src={logo} alt="logo" />
      </div>

      <div
        className="lg:hidden cursor-pointer"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <div className="w-6 h-0.5 bg-gray-800 mb-1"></div>
        <div className="w-6 h-0.5 bg-gray-800 mb-1"></div>
        <div className="w-6 h-0.5 bg-gray-800"></div>
      </div>

      {isMobile ? (
        <Fragment />
      ) : (
        <div className="flex header__pages space-x-6">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link !font-bold"
                : "header__pages__link"
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/solutions"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link !font-bold"
                : "header__pages__link"
            }
          >
            Solutions
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link !font-bold"
                : "header__pages__link"
            }
          >
            About Us
          </NavLink>
          <NavLink
            to="/faq"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link !font-bold"
                : "header__pages__link"
            }
          >
            FAQ's
          </NavLink>
          {/* <NavLink
            to="/blog"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link !font-bold"
                : "header__pages__link"
            }
          >
            Insights
          </NavLink> */}
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link !font-bold"
                : "header__pages__link"
            }
          >
            Contact
          </NavLink>
        </div>
      )}

      {isMobile ? (
        <Fragment />
      ) : (
        <Fragment>
          {user ? (
            <div className="header__buttons hidden lg:flex space-x-4">
              <NavLink to="/dashboard" className="header__buttons__in">
                Dashboard
              </NavLink>
            </div>
          ) : (
            <div className="header__buttons hidden lg:flex space-x-4">
              <NavLink to="/register" className="header__buttons__up">
                Sign up
              </NavLink>
              <NavLink to="/login" className="header__buttons__in">
                Log in
              </NavLink>
            </div>
          )}
        </Fragment>
      )}

      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40"
          onClick={() => setIsMenuOpen(false)}
        ></div>
      )}
      <aside
        className={`fixed top-0 right-0 h-full bg-white w-64 shadow-md transform transition-transform ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        } z-50`}
      >
        <button
          className="absolute top-4 right-4 text-gray-800"
          onClick={() => setIsMenuOpen(false)}
        >
          ✕
        </button>
        <nav className="flex flex-col p-4 space-y-4">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link font-bold text-gray-800 px-4"
                : "header__pages__link text-gray-600 px-4"
            }
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </NavLink>
          <NavLink
            to="/solutions"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link font-bold text-gray-800 px-4"
                : "header__pages__link text-gray-600 px-4"
            }
            onClick={() => setIsMenuOpen(false)}
          >
            Solutions
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link font-bold text-gray-800 px-4"
                : "header__pages__link text-gray-600 px-4"
            }
            onClick={() => setIsMenuOpen(false)}
          >
            About Us
          </NavLink>
          <NavLink
            to="/faq"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link font-bold text-gray-800 px-4"
                : "header__pages__link text-gray-600 px-4"
            }
            onClick={() => setIsMenuOpen(false)}
          >
            FAQ's
          </NavLink>
          {/* <NavLink
            to="/blog"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link font-bold text-gray-800 px-4"
                : "header__pages__link text-gray-600 px-4"
            }
            onClick={() => setIsMenuOpen(false)}
          >
            Insights
          </NavLink> */}
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive
                ? "header__pages__link font-bold text-gray-800 px-4"
                : "header__pages__link text-gray-600 px-4"
            }
            onClick={() => setIsMenuOpen(false)}
          >
            Contact
          </NavLink>

          <Fragment>
            <InstallPWAButton onInstall={() => {}} renderButton={(onClick) => (
                <div
                    onClick={onClick}
                    className="flex bg-[#202A43] text-white rounded-lg px-4 py-2 items-center justify-start gap-2 w-fit cursor-pointer">
                  Download App
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="14"
                      viewBox="0 0 8 10"
                      fill="none"
                  >
                    <g clip-path="url(#clip0_2812_1728)">
                      <path
                          d="M8.00012 4.45319L3.96349 8.12298L0.00096468 4.40831C-0.0310387 4.27604 0.742937 3.67451 0.880215 3.51783L3.33268 5.7027V0H4.66672V5.7027L7.04844 3.51783L8.00096 4.29651V4.45241L8.00012 4.45319Z"
                          fill="white"
                      />
                      <path
                          d="M7.6667 8.75H0.332031V10.0003H7.6667V8.75Z"
                          fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2812_1728">
                        <rect width="8" height="10" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
            )} />
          </Fragment>

          {/* <NavLink to="/register" className="header__buttons__up">
            Sign up
          </NavLink>
          <NavLink to="/login" className="header__buttons__in">
            Log in
          </NavLink> */}
        </nav>
      </aside>
    </div>
  );
};

export default Header;
